<!-- =========================================================================================
    File Name: TechnicAddNew.vue
    Description: Add new technic component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="technic__filters-container">
    <!-- all -->
    <div class="px-6 pt-2">
      <div id="divDisplayAll"
        class="flex items-center cursor-pointer"
        :class="{'text-primary': Filter.filter1 == '' && Filter.filter2 == ''}"
        @click="FilterItems('', 0)"
      >
        <feather-icon
          icon="ClipboardIcon"
          :svgClasses="[{'text-primary stroke-current':Filter.filter1 == '' && Filter.filter2 == ''},'h-6 w-6']"
        ></feather-icon>
        <span class="text-lg ml-3">Tümünü Göster</span>
      </div>
      <div class="flex items-center mt-2 cursor-pointer"  @click="FilterItems('Süresi Geçen', 3)"  key="Süresi Geçen">
          <feather-icon icon="ClockIcon" class="danger" style="width:16px;margin-top:1px"></feather-icon>
          <span id="lblExpired" class="text-lg ml-3">Süresi Geçen</span>
        </div>
    </div>

    <vs-divider class="m-2"></vs-divider>

    <!-- starred -->
    <div class="px-6 py-0">
      <div class="vx-row px-6">
        <h5>Listele</h5>

        <div class="vs-spacer"></div>
        <a href="#" class="flex items-center"
          ><feather-icon
            class="satirIcon right-align"
            icon="Trash2Icon"
            @click="clearFilter(1)"
          ></feather-icon
        ></a>
      </div>
      <template>
        <div
          class="flex items-center cursor-pointer -mt-1 "
          @click="FilterItems(current.value, 1)"
           v-for="current in filterType1"
          :key="current.filter"
        >
          <feather-icon
          style="width:16px!important"
            :icon="current.other.icon?current.other.icon:'Trash2Icon'"
            :class="current.classList"
          ></feather-icon>
          <span class="text-md ml-3"
            :class="{ 'text-primary': Filter.filter1 == current.value }">{{ current.value }}</span>
        </div>
      </template>
    </div>

    <vs-divider class="m-2"></vs-divider>

    <div class="px-6 py-0">
      <div class="vx-row px-6 flex items-center" >
        <h5>Tür</h5>
        <div class="vs-spacer"></div>
        <a href="#"
          ><feather-icon
            class="satirIcon right-align"
            icon="Trash2Icon"
            @click="clearFilter(2)"
          ></feather-icon
        ></a>
      </div>

      <div class="technic__lables-list ">
        <div
          class="technic__label flex items-center mt-1 cursor-pointer "
          :class="{ 'text-primary': Filter.filter2 == current.value }"
          v-for="current in filterType2"
          :key="current.value"
          @click="FilterItems(current.value, 2)"
        >
          <i 
            class="filterIcon"
            style="font-size:16px!important"
            :class="'vs-icon notranslate icon-scale material-icons ' +current.classList">{{ current.other.icon }}</i>
          <span class="text-lg ml-3">{{ current.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  props: {
    filter1: {
      type: Array,
      required: true
    },
    filter2: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      Filter: { filter1: "", filter2: "" },
      MoveFilterUp: 999,
    };
  },
  computed: {
    filterType2() {
      return repository.convertToJSON(this.filter2, "other");
    },
    filterType1() {
      return repository.convertToJSON(this.filter1.filter(x=>x.id!=this.MoveFilterUp),"other");
    }
  },
  methods: {
    clearFilter(r) {
      switch (r) {
        case 1:
          this.Filter.filter1 = "";
          break;
        case 2:
          this.Filter.filter2 = "";
          break;
      }
      this.$emit("filterItems", this.Filter);
    },
    FilterItems(filterName, v) {
      switch (v) {
        case 0:
          this.Filter.filter1 = "";
          this.Filter.filter2 = "";
          this.Filter.expired = "";
          document.getElementById("divDisplayAll").classList.add("text-primary");
          document.getElementById("lblExpired").classList.remove("text-primary");
          break;
        case 1:
          this.Filter.filter1 = filterName;
          break;
        case 2:
          this.Filter.filter2 = filterName;
          break;
        case 3:
          this.Filter.expired = filterName;
          document.getElementById("divDisplayAll").classList.remove("text-primary");
          document.getElementById("lblExpired").classList.add("text-primary");
          break;
      }
      this.$emit("filterItems", this.Filter);
    }
  }
};
</script>
